module.exports = require("@vuepic/vue-datepicker");